module.exports = "https://static.wmbcdn.com/uniweb/images/fd1a1af451e3df8afb66bc492a3512c5.png";